import PositionTheWorkStep from './positionTheWork';
import PositionTheWorkLocationStep from './positionTheWorkLocation';
import PositionThePayStep from './positionThePay';
import PositionTheWorkerStep from './positionTheWorker';
import PositionTheReviewStep from './positionTheReview';

export { PositionTheWorkStep, PositionTheWorkLocationStep, PositionThePayStep, PositionTheWorkerStep, PositionTheReviewStep };



// WEBPACK FOOTER //
// ./src/pages/position/steps/index.js